import React, { useState } from 'react'
import { get } from 'lodash'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import CoachCardSm from 'components/coach-card-small'
import StepDescription from '../step-description'
import { useStyles } from './styles'
import LocationDropdown from './location-dropdown'
import GroupedLessonTypes from './grouped-lesson-types'

export default ({ data, allowedToOverrideInactive, coach }) => {
  const {
    coachName,
    coachTitle,
    coachAvatar,
    coachLocations,
    lessonTypes,
  } = data
  const [selectedFacility, setSelectedFacility] = useState(
    get(coachLocations, '0.id', null),
  )
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <Grid container>
        <Grid item md={7} xs={12}>
          <StepDescription
            stepText="Step 1 of 4"
            title="Coach offerings"
            description="Select from this list of coach offerings below.
              You can filter this list by the coach's available locations as well."
          />
        </Grid>
        <Grid item md={3} xs={12} style={{ marginLeft: 'auto' }}>
          <CoachCardSm
            coach={{ name: coachName, coachAvatar, facilityName: coachTitle }}
          />
        </Grid>
        <Grid container item spacing={2}>
          <Grid item md={4} xs={12}>
            <LocationDropdown
              selectedFacility={selectedFacility}
              setSelectedFacility={setSelectedFacility}
              locations={coachLocations}
            />
          </Grid>
        </Grid>
      </Grid>
      <GroupedLessonTypes
        selectedFacility={selectedFacility}
        lessonTypes={lessonTypes}
        classes={classes}
        allowedToOverrideInactive={allowedToOverrideInactive}
        isSingleSession={true}
        coachExternalId={coach?.externalId}
        coachName={coachName}
      />
    </Container>
  )
}
